import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadAdsAccount } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export const getAdsAccounts = async (
  integrationId: string,
): Promise<ReadAdsAccount[]> => {
  return await tinctApi.crmIntegrations.getAdsAccounts(integrationId);
};

/**
 * Ad accounts readable through an ads integration. Live call to the provider
 * (may take a second); a 401 on an expired token surfaces server-side as the
 * integration's `needsReauthorization` flag.
 */
export const useGetAdsAccounts = (
  integrationId: string | undefined,
  options?: Omit<
    UseQueryOptions<ReadAdsAccount[], ApiError>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    queryKey: ['ads-accounts', integrationId],
    queryFn: () => getAdsAccounts(integrationId as string),
    enabled: !!integrationId,
    ...options,
  });
